import i18n from 'i18next';

import { DoclingOCRProviderEngine, OCRProviderSettingsType, Settings6 } from '../../../../../gamma-api';

import {
  DOCLING_REFERENCE_DOC_URL,
  DOCLING_SERVER_BASE_URL,
  DOCLING_SERVER_DOCS_PATH,
  EASY_OCR_EXTRA_PARAMS_EN,
  EASY_OCR_EXTRA_PARAMS_RU,
  EMPTY_DOCLING_OCR_SETTINGS,
  EMPTY_DOCLING_OCR_SETTINGS_EN,
  EMPTY_DOCLING_OCR_SETTINGS_RU,
  EMPTY_VLM_OCR_SETTINGS,
  RAPID_OCR_EXTRA_PARAMS_EN,
  RAPID_OCR_EXTRA_PARAMS_RU,
  TESSERACT_EXTRA_PARAMS_EN,
  TESSERACT_EXTRA_PARAMS_RU,
} from './const';

export const isRussianOcrLocale = (): boolean => {
  return (i18n.resolvedLanguage || i18n.language).includes('ru');
};

export const getDoclingServerDocsUrl = (baseUrl?: string): string => {
  if (!baseUrl) {
    baseUrl = DOCLING_SERVER_BASE_URL;
  }

  try {
    const urlObj = new URL(DOCLING_SERVER_DOCS_PATH, baseUrl);
    return urlObj.href;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Failed to construct Docling server docs URL:', error);
    return `${baseUrl}/${DOCLING_SERVER_DOCS_PATH}`;
  }
};

export const getDoclingReferenceDocUrl = (): string => {
  return DOCLING_REFERENCE_DOC_URL;
};

export const getEmptyOcrSettings = (type: OCRProviderSettingsType): Settings6 => {
  if (type === OCRProviderSettingsType.Vlm) {
    return EMPTY_VLM_OCR_SETTINGS;
  }

  if (type === OCRProviderSettingsType.Docling) {
    if (isRussianOcrLocale()) {
      return EMPTY_DOCLING_OCR_SETTINGS_RU;
    }

    return EMPTY_DOCLING_OCR_SETTINGS_EN;
  }

  return EMPTY_DOCLING_OCR_SETTINGS;
};

export const getOcrExtraParams = (engine: DoclingOCRProviderEngine): { [key: string]: unknown } => {
  if (engine === DoclingOCRProviderEngine.EasyOcr) {
    if (isRussianOcrLocale()) {
      return EASY_OCR_EXTRA_PARAMS_RU;
    }

    return EASY_OCR_EXTRA_PARAMS_EN;
  }

  if (engine === DoclingOCRProviderEngine.RapidOcr) {
    if (isRussianOcrLocale()) {
      return RAPID_OCR_EXTRA_PARAMS_RU;
    }

    return RAPID_OCR_EXTRA_PARAMS_EN;
  }

  if (engine === DoclingOCRProviderEngine.Tesseract) {
    if (isRussianOcrLocale()) {
      return TESSERACT_EXTRA_PARAMS_RU;
    }

    return TESSERACT_EXTRA_PARAMS_EN;
  }

  return {};
};
